<div class="modal-header">
  <div class="icon-title">
    <fa-icon
      class="ml-1 mt-1 mr-3 icon-left fa-icon-color--warning"
      size="2x"
      fa-fw="true"
      [icon]="['fas', 'exclamation-circle']"
    >
    </fa-icon>
    <h3 class="modal-title" id="modal-basic-title">{{ "modalReuseSignatures.title" | translate }}</h3>
  </div>
  <button
    class="cdx-button__close"
    type="button"
    aria-label="Close"
    (click)="closeModal.emit()"
  >
    <fa-icon [icon]="['far', 'times']" fa-fw="true"></fa-icon>
  </button>
</div>
<div class="modal-body">
  <p *ngIf="!isMoreThanOneRejected" [innerHTML]="'modalReuseSignatures.subtitle' | translate"></p>
  <p *ngIf="isMoreThanOneRejected" [innerHTML]="'modalReuseSignatures.subtitlePlural' | translate"></p>
</div>
<div class="modal-footer" style="flex-wrap: nowrap">
  <button
    class="cdx-button cdx-button--ternary mr-2"
    (click)="closeModal.emit()"
  >
    <span class="cdx-button__text">{{ "cancel" | translate }}</span>
  </button>
  <button class="cdx-button cdx-button--ternary mr-2" (click)="confirmModal.emit(false)">
    <span class="cdx-button__text">{{ "modalReuseSignatures.btnSignatureAgain" | translate }}</span>
  </button>
  <button class="cdx-button cdx-button--primary cdx-button--warning" (click)="confirmModal.emit(true)">
    <span class="cdx-button__text">{{ "modalReuseSignatures.btnUseSignatures" | translate }}</span>
  </button>
</div>
